import type { Profile } from "../types/database";

export type AccessRequirement = "allowlisted-player" | "admin";

export type AccessDecision =
  | { allowed: true }
  | { allowed: false; reason: "not-allowlisted" | "not-admin" };

export function decideAccess(profile: Profile, requirement: AccessRequirement): AccessDecision {
  if (requirement === "admin") {
    return profile.role === "admin" ? { allowed: true } : { allowed: false, reason: "not-admin" };
  }

  return profile.allowlisted
    ? { allowed: true }
    : { allowed: false, reason: "not-allowlisted" };
}
